import { useState, useEffect } from 'react'

const MIN_DISPLAY_MS = 2500
const FADE_MS = 600

interface Props {
  onDone: () => void
}

export function LoadingScreen({ onDone }: Props) {
  const [opacity, setOpacity] = useState(1)

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(0)
      setTimeout(onDone, FADE_MS)
    }, MIN_DISPLAY_MS)

    return () => clearTimeout(timer)
  }, [onDone])

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-surface"
      style={{
        opacity,
        transition: `opacity ${FADE_MS}ms ease-in-out`,
      }}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-text-muted text-sm tracking-wide">Loading...</p>
      </div>
    </div>
  )
}
